/* ─── Scroll-reveal via Intersection Observer ───────────────────────── */ 'use strict';
(function() {
    if (!('IntersectionObserver' in window)) {
        /* Fallback: show everything for unsupported browsers */ document.querySelectorAll('[data-animate]').forEach(function(el) {
            el.classList.add('is-visible');
        });
        return;
    }
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px'
    });
    document.querySelectorAll('[data-animate]').forEach(function(el) {
        observer.observe(el);
    });
})();

//# sourceMappingURL=project-6a0985f11bbc35ebaa3a06b4.79c23616.js.map
